module.exports = __webpack_public_path__ + "static/media/store_image.4fddf5ea.svg";